import { useEffect, useState } from "react";
import { reformatData } from "../../../util/helperFunctions";

function useFetchMissingFeature({
    sensorID, start, end, interval
}) {
    const [resetWTIndexes, setResetWTIndexes] = useState(null);
    const [missingFeature, setMissingFeature] = useState(null);

    useEffect(() => {
        // c3request("PermasenseIdentifier", "evalMetrics", {
        //     spec: {
        //         ids: [sensorID],
        //         expressions: ["ResetWallThickness_RHE", "MissingAvailability"],
        //         start: start,
        //         end: end,
        //         interval: interval.value,
        //         include: "data, dates, missing, unit, start, end, count",
        //     },
        // }).then((sensorData) => {
        //     sensorData = reformatData([sensorData])[0];
        //     if (sensorData?.result) {
        //         const indexes = sensorData?.result[sensorID]?.ResetWallThickness_RHE.data?.reduce((accumulator, current, index) => {
        //             if (current === 1) {
        //                 accumulator.push(index - 1);
        //             }
        //             return accumulator;
        //         }, []);
        //         indexes.shift();
        //         setResetWTIndexes(indexes);
        //         setMissingFeature(sensorData?.result[sensorID]?.MissingAvailability);
        //     }
        // }).catch((error) => { console.log(error); });
    }, [start, end, interval, sensorID])

    return { missingFeature, resetWTIndexes }
}


export default useFetchMissingFeature;